const YOUTUBE_REGEX = /(?:youtube\.com\/(?:watch\?(?:.*&)?v=|embed\/|shorts\/)|youtu\.be\/)([A-Za-z0-9_-]{11})/;

export const getYouTubeId = (url: string): string | null => {
	const match = url.match(YOUTUBE_REGEX);
	return match ? match[1] : null;
};

export const getYouTubeThumbnail = (videoUrl: string): string | null => {
	const id = getYouTubeId(videoUrl);
	return id ? `https://img.youtube.com/vi/${id}/hqdefault.jpg` : null;
};

export const isVideoEntry = (entry: { videoUrl?: string }): boolean => Boolean(entry.videoUrl);
